import { render, staticRenderFns } from "./UserRegister.vue?vue&type=template&id=5bac97cc&scoped=true"
import script from "./UserRegister.vue?vue&type=script&lang=js"
export * from "./UserRegister.vue?vue&type=script&lang=js"
import style0 from "./UserRegister.vue?vue&type=style&index=0&id=5bac97cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bac97cc",
  null
  
)

export default component.exports